// src/actions/user.constant.js

export const userConstants = {
  EMAIL_LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  EMAIL_LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  EMAIL_LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  MSAL_LOGIN_REQUEST: "MSAL_USERS_LOGIN_REQUEST",
  MSAL_LOGIN_SUCCESS: "MSAL_USERS_LOGIN_SUCCESS",
  MSAL_LOGIN_FAILURE: "MSAL_USERS_LOGIN_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  GETALL_REQUEST: "USERS_GETALL_REQUEST",
  GETALL_SUCCESS: "USERS_GETALL_SUCCESS",
  GETALL_FAILURE: "USERS_GETALL_FAILURE",

  DELETE_REQUEST: "USERS_DELETE_REQUEST",
  DELETE_SUCCESS: "USERS_DELETE_SUCCESS",
  DELETE_FAILURE: "USERS_DELETE_FAILURE",
};
